import React from "react";
import { Row, Col } from "react-bootstrap";
import _ from "lodash";

import "./style.scss";

export const CombineWith = ({ title, field_reference_combine_programs }) => {
    return (
        <Row className="combine-with">
            {Array.isArray(field_reference_combine_programs) && (
                <Col tabIndex="0" aria-label={title} sm={12} md={12} className="combine-title">
                    {title}
                </Col>
            )}
            <Col sm={12} md={12} className="combine-programs">
                <Row className="programs-wrapper">
                    {Object.keys(field_reference_combine_programs).map((cp, i) => (
                        i < 3 && (
                            <Col sm={2} md={2} key={i} className="program" aria-labelledby={`title${i} faculty${i}`} tabIndex="0">
                                <Row className="program-and-faculty align-items-center">
                                    <Col className="p-0">
                                        <a href={`node/${field_reference_combine_programs[cp]?.nid}`} target="_blank">
                                            <p className="program-title"
                                                id={`title${i}`}
                                                dangerouslySetInnerHTML={{
                                                    __html: field_reference_combine_programs[cp]?.title,
                                                }}
                                            />
                                        </a>

                                        <p className="faculty-title"
                                            id={`faculty${i}`}
                                            dangerouslySetInnerHTML={{
                                                __html: field_reference_combine_programs[cp]?.faculty_title,
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        )
                    ))}
                </Row>
            </Col>
        </Row>
    )
}